<template>
  <ElDropdown trigger="click" @command="handleCommand">
    <slot />
    <ElDropdownMenu slot="dropdown">
      <ElDropdownItem
        v-for="(item, index) in items"
        :key="index"
        :command="index"
        :disabled="item.disabled"
      >
        {{ item.title }}
      </ElDropdownItem>
    </ElDropdownMenu>
  </ElDropdown>
</template>

<script>
export default {
  name: 'LbDropdown',
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  methods: {
    handleCommand(command) {
      const selectedItem = this.items[command];
      selectedItem.handler();
    },
  },
};
</script>
